import { useRequest } from '../init-plugin';

export async function getApiData(
  params: { [key: string]: any },
  url: string,
  is_tree?: boolean,
  options: any = {},
): Promise<any> {
  if (is_tree) {
    const res: any = await useRequest().post(url, params, options);
    // 创建一个映射，用于快速查找元素
    const map = new Map<string, any>(
      res.data.map(item => [
        item.id,
        { ...item, key: item.id, value: item.id, title: item.name, children: [] },
      ]),
    );
    const result = [];

    // 构建嵌套结构
    res.data.forEach(item => {
      item.key = item.id;
      item.value = item.id;
      item.title = item.name;
      if (item.parent_id !== null && map.get(item.parent_id)?.children) {
        map.get(item.parent_id).children.push(map.get(item.id));
      } else {
        // 根节点直接添加到结果数组中
        result.push(map.get(item.id));
      }
    });

    // 递归排序函数
    function sortChildren(nodes) {
      nodes.forEach(node => {
        if (node?.children && node.children.length > 0) {
          node.children.sort((a, b) => a.sort - b.sort); // 按照sort排序
          sortChildren(node.children); // 递归排序子节点
        } else {
          delete node.children;
        }
      });
    }

    // 对结果数组中的每个根节点进行排序和子节点排序
    result.sort((a, b) => a.sort - b.sort); // 先对根节点排序
    sortChildren(result); // 然后递归地对每个根节点的子节点排序

    res.data = result;
    if (result.length != 0) {
      res.data = result;
      res.total = result.length;
    } else {
      res.total = res.data.length;
    }
    return res;
  } else {
    return useRequest().post(url, params, options);
  }
}

export async function getApiUpload(
  params: Record<string, any>,
  url: string,
  options,
): Promise<any> {
  return useRequest().post(url, params, options);
}

export async function getApiUploadPut(
  params: Record<string, any>,
  url: string,
  options,
): Promise<any> {
  return useRequest().put(url, params, options);
}

const apiDataCache = {};
export function cachedGetApiData(
  cache_key: string,
  params: { [key: string]: any },
  url: string,
  is_tree?: boolean,
  options: any = {},
): Promise<any> {
  if (apiDataCache[cache_key]) {
    return apiDataCache[cache_key];
  } else {
    return (apiDataCache[cache_key] = getApiData(params, url, is_tree, options));
  }
}
